import { IBaseTextBoxProps, BaseTextBox } from "./BaseTextBox";

import { IValidationCondition } from "./Validation/IValidationCondition";

import { IValidationRule } from "./Validation/IValidationRule";

import { isEmpty, isDate } from "./Validation/RawValueRules";

import {
    dateValueIsAtLeast,
    valueIsAtLeast,
    valueIsAtMost,
    valueIsLessThan,
    valueIsMoreThan,
} from "./Validation/NumericValueRules";
import { Content } from "./Resources/Content";

export interface IDateTextBoxSpecificProps extends IBaseTextBoxProps<Date> {
    acceptDateFormats?: string[];
    dateFormat?: string;
    atLeast?: IValidationCondition<Date>;
    atMost?: IValidationCondition<Date>;
    lessThan?: IValidationCondition<Date>;
    moreThan?: IValidationCondition<Date>;
    validationRules?: IValidationRule<Date>[];
    isTypingFinished?: boolean;
}

export interface IDateTextBoxProps extends IDateTextBoxSpecificProps, React.Props<DateTextBox> {
    // NOTE: leave empty
}

export class DateTextBox extends BaseTextBox<Date, IDateTextBoxProps> {
    private static defaultDateFormat = "d";

    constructor(props: IDateTextBoxProps) {
        super(props);
    }

    public componentDidUpdate(prevProps: IDateTextBoxProps): void {
        if (this.props.isTypingFinished && !prevProps.isTypingFinished) {
            this.runValidation(this.state.value);
        }

        super.componentDidUpdate(prevProps);
    }

    protected isParsable(input: string): boolean {
        return isDate(input, this.getAcceptDateFormats());
    }

    protected parseValue(input: string): Date {
        return isEmpty(input) ? null : Globalize.parseDate(input, this.getAcceptDateFormats());
    }

    protected formatDisplayValue(value: Date): string {
        return value !== null && value !== undefined ? Globalize.format(value, this.getDateFormat()) : "";
    }

    protected initRawValidation(): void {
        super.initRawValidation();

        this.validator.rawValidator.add(
            (value) => isDate(value, this.getAcceptDateFormats()),
            Content.Value_must_be_a_valid_date
        );
    }

    protected initParsedValidation(): void {
        super.initParsedValidation();

        this.validator.parsedValidator.addFromCondition(this.props.atLeast, dateValueIsAtLeast);
        this.validator.parsedValidator.addFromCondition(this.props.atMost, valueIsAtMost);
        this.validator.parsedValidator.addFromCondition(this.props.lessThan, valueIsLessThan);
        this.validator.parsedValidator.addFromCondition(this.props.moreThan, valueIsMoreThan);

        this.validator.parsedValidator.addRange(this.props.validationRules);
    }

    protected getAcceptDateFormats(): string[] {
        return this.props.acceptDateFormats || [this.getDateFormat()];
    }

    protected getDateFormat(): string {
        return this.props.dateFormat || DateTextBox.defaultDateFormat;
    }
}
